import React from 'react';
import PropTypes from 'prop-types';

import Button from '../buttons/Button';

class Announcement extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      announcements: props.announcements,
    };
  }

  componentDidMount() {
    if (
      this.state.announcements &&
      (this.state.announcements.new.length > 0 || this.state.announcements.old.length > 0)
    ) {
      this.updateAnnouncements();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.announcements && newProps.announcements.new.length > 0) {
      this.setState({ announcements: newProps.announcements }, () => {
        this.updateAnnouncements();
      });
    }
  }

  updateAnnouncements() {
    const announcement = document.getElementById('announcements');
    const announcements = this.state.announcements.new || [];
    const oldAnnouncements = this.state.announcements.old || [];
    announcement.innerHTML = '';

    announcements.forEach((a) => {
      announcement.innerHTML += '<div class="announcement-container">' + a + '<div/>';
    });

    oldAnnouncements.forEach((a) => {
      announcement.innerHTML += '<div class="announcement-container">' + a + '<div/>';
    });
  }

  render() {
    return (
      <div className="announcement-modal-container">
        <div className="close-btn-container">
          <span className="close-btn" onClick={this.props.close}>
            <i className="fa fa-times" />
          </span>
        </div>

        <div className={'messages-container'}>
          <h2> Announcements </h2>
          <div id="announcements">
            <p> No notifications</p>
          </div>
        </div>
      </div>
    );
  }
}

Announcement.propTypes = {
  announcements: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  close: PropTypes.func,
};

export default Announcement;
